import React from "react";
import { Button } from "cxa-components";
import classnames from "classnames";
import walletProps from "./walletProps";
import accounting from "accounting";
import StandardMoney from "../../common/StandardMoney";

const MiniWallet = ({
  walletName,
  totalPrefix,
  totalBalance,
  currency,
  selectedPrefix,
  spentAmount,
  remainingText,
  remainingBalance,
  isSaving,
  onClick,
  buttonText,
  isTabletScreen,
  isPhoneScreen,
}) => {
  const remainingBalanceValue = accounting.unformat(remainingBalance).toFixed(2);
  return (
    <article className="apl-cart apl-cart--mini cxa-mini-wallet">
      <header>{walletName}</header>
      {
        // <section className="cxa-mini-wallet__spacing" />
      }
      <section className="cxa-mini-wallet__fields">
        {isTabletScreen && (
          <section className="cxa-mini-wallet__field">
            <header>{totalPrefix}</header>
            <p className="cxa-wallet__balance">
              <StandardMoney value={totalBalance} currency={currency} postfix />
            </p>
          </section>
        )}
        {
          <section className="cxa-mini-wallet__field">
            <header>{selectedPrefix}</header>
            <p>
              <StandardMoney value={spentAmount} currency={currency} postfix />
            </p>
          </section>
        }
        {
          <section className="cxa-mini-wallet__field">
            <header>{remainingText}</header>
            <p>
              <StandardMoney value={remainingBalanceValue} currency={currency} postfix />
            </p>
          </section>
        }
        {isTabletScreen && (
          <section
            className={classnames("cxa-mini-wallet__field", "cxa-mini-wallet__field--button")}
          >
            <Button primary submitting={isSaving} onClick={onClick} style={{ width: "100%" }}>
              {buttonText}
            </Button>
          </section>
        )}
      </section>
      {isPhoneScreen && (
        <section className="cxa-mini-wallet__fields cxa-mini-wallet__fields--overflow">
          <section
            className={classnames(
              "cxa-mini-wallet__field",
              "cxa-mini-wallet__field--button",
              "cxa-mini-wallet__field--button__overflow"
            )}
          >
            <Button primary submitting={isSaving} onClick={onClick} style={{ width: "100%" }}>
              {buttonText}
            </Button>
          </section>
        </section>
      )}
    </article>
  );
};

MiniWallet.propTypes = {
  ...walletProps,
};

export default MiniWallet;



// WEBPACK FOOTER //
// ./components/employee/shop/MiniWallet.js